// frontend/src/utils/urlHelper.js

/**
 * Normalizes a logo URL.
 * 1. Handles relative paths by prepending the API base URL.
 * 2. Converts Google Drive sharing/view links into direct download links.
 * 
 * @param {string} url - The raw URL string.
 * @returns {string} - The normalized, direct-access URL.
 */
export function normalizeLogoUrl(url) {
    if (!url) return url;

    // 1. Handle relative paths (e.g., /uploads/logo.png)
    if (url.startsWith('/')) {
        const baseUrl = (process.env.REACT_APP_API_URL || 'http://localhost:4000').replace('/api', '').replace(/\/+$/, '');
        return `${baseUrl}${url}`;
    }

    // 2. Handle Google Drive links
    // Formats:
    // https://drive.google.com/file/d/FILE_ID/view?usp=sharing
    // https://drive.google.com/open?id=FILE_ID
    try {
        if (url.includes('drive.google.com')) {
            let fileId = '';

            // Pattern 1: /file/d/FILE_ID/
            if (url.includes('/file/d/')) {
                const parts = url.split('/file/d/');
                if (parts.length > 1) {
                    fileId = parts[1].split('/')[0].split('?')[0];
                }
            }
            // Pattern 2: ?id=FILE_ID or &id=FILE_ID
            else if (url.includes('id=')) {
                const urlObj = new URL(url);
                fileId = urlObj.searchParams.get('id');
            }

            if (fileId) {
                // Return the direct download format
                return `https://drive.google.com/uc?export=view&id=${fileId}`;
            }
        }
    } catch (err) {
        console.warn('[urlHelper] Failed to parse Google Drive URL:', err);
    }

    return url;
}
